<template>
  <div class="keyong">
    <!-- 可用套餐 -->
    <div class="top">
      <Select v-model="model1" class="select" @on-change="getSelect" label-in-value>
        <Option v-for="(item, index) in typeList" :value="item.id" :key="index">{{ item.classifyName }}</Option>
      </Select>
      <Input @on-clear="selectUploadedBasExamSuiteList(1)" @on-enter="selectUploadedBasExamSuiteList(1)" placeholder="搜索" class="journal-input" clearable v-model="name">
      <Icon type="ios-search" slot="prefix" />
      </Input>
      <Button class="title-btn2" type="success" @click="tonewClassifyManage" ghost>套餐分类管理</Button>
      <Button class="title-btn2" type="success" @click="tonewAddClassify()" ghost>新增套餐分类</Button>
      <Button class="title-btn fourSize" type="success" @click="tonewAdd" ghost>新增套餐</Button>
      <!-- <Button class="title-btn2" type="success" @click="setSpecialSuit" ghost>设置特殊套餐</Button> -->
    </div>
    <Modal class="ivumodal" width="500" v-model="ishow" :title="TitleClassify" footer-hide>
      <div class="modal-cont">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="170">
          <FormItem label="套餐分类名称：" prop="classifyName" class="bumenModal-item">
            <Input v-model="formValidate.classifyName" placeholder="" style="color:#7F7F7F" />
          </FormItem>
          <FormItem label="套餐分类说明：" prop="classifyNote" class="bumenModal-item">
            <i-input class="textarea" v-model.trim="formValidate.classifyNote" type="textarea" :autosize="{ minRows: 6, maxRows: 6 }" placeholder="请输入..."></i-input>
          </FormItem>
          <FormItem label="状态：" prop="currentType" class="bumenModal-item">
            <RadioGroup v-model="formValidate.currentType">
              <Radio label='1'>
                <span>启用</span>
              </Radio>
              <Radio label='0' style="margin-left:50px;">
                <span>停用</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Form>
        <div class="secondBumen-bottom">
          <Button class="btn" type="success" ghost @click="formValidateReset('formValidate')">取消</Button>
          <Button class="btn sure" type="success" ghost @click="formValidateSubmit('formValidate')">确定</Button>
        </div>
      </div>
    </Modal>
    <Modal class="ivumodal" width="800" v-model="ishowClassify" title="套餐分类管理" footer-hide>
      <div class="table-cont">
        <Table @on-sort-change="changesort" stripe :columns="columnsClassify" :data="dataClassify"></Table>
      </div>
    </Modal>
    <div class="table-cont">
      <Table @on-selection-change="selectChange" @on-sort-change="changesort" stripe :columns="columns" :data="data"></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        <div class="left">
          已选 <span>{{ selectNum }}</span> 条
        </div>
        <Button class="title-btn fourSize" type="success" ghost @click="tongbu">同步套餐</Button>
        <Button class="title-btn fourSize" type="success" ghost @click="piliang">批量修改</Button>
      </div>
      <Page :total="obj.total" @on-page-size-change="changepeoplepage" @on-change="changePeoplecurrent" show-elevator show-total :current="current" :page-size="pageSize" show-sizer class="page-div-page" />
    </div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert>
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{ alertTitle }}</Alert>

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->

    <!--新增套餐弹框 -->
    <Modal class="ivumodal" footer-hide width="800" v-model="addShow" :title="Title">
      <Add ref="Add" :classifyId="model1" @postSelectd="getSelectd"></Add>
      <!-- <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="clear(1)">取消</Button>
        <Button class="btn sure" type="success" ghost @click="clear(2)"
          >确定</Button
        >
      </div> -->
    </Modal>
    <!-- 批量修改套餐弹框 -->
    <Modal class="ivumodal" footer-hide width="500" v-model="modify" title="修改">
      <Form ref="xiugai" :model="xiugai" :rules="xiugaidata" :label-width="170">
        <FormItem v-show="isShuoming" label="操作条数：" prop="num" class="bumenModal-item">
          <div>
            <span>{{ selectedNum }}</span> 条
          </div>
        </FormItem>
        <FormItem v-show="!isShuoming" label="套餐说明：" prop="instructions" class="bumenModal-item">
          <Input v-model="xiugai.instructions" type="textarea" :rows="4" placeholder="请输入套餐说明" />
        </FormItem>
        <FormItem v-show="!isShuoming" label="婚姻状态：" prop="marry" class="bumenModal-item">
          <RadioGroup v-model="xiugai.marry">
            <Radio label="已婚">
              <span>已婚</span>
            </Radio>
            <Radio label="未婚" style="margin-left:50px;">
              <span>未婚</span>
            </Radio>
            <Radio label="不限" style="margin-left:50px;">
              <span>不限</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="可用状态：" prop="select" class="bumenModal-item">
          <RadioGroup v-model="xiugai.select">
            <Radio label="1">
              <span>启用</span>
            </Radio>
            <Radio label="0" style="margin-left:50px;">
              <span>停用</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-show="!isShuoming" label="注意事项：" prop="precautions" class="bumenModal-item">
          <Input v-model="xiugai.precautions" type="textarea" :rows="4" placeholder="请输入注意事项" />
        </FormItem>
        <!-- <FormItem label="特殊套餐：" prop="select" class="bumenModal-item">
          <RadioGroup v-model="xiugai.">
            <Radio label="1">
              <span>是</span>
            </Radio>
            <Radio label="0" style="margin-left:50px;">
              <span>否</span>
            </Radio>
          </RadioGroup>
        </FormItem> -->
      </Form>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="clear(1, 'xiugai')">取消</Button>
        <Button class="btn sure" type="success" ghost @click="clear(3, 'xiugai')">确定</Button>
      </div>
    </Modal>
    <!-- 提示弹框 -->
    <Modal footer-hide class="ivumodal" width="500" v-model="errors" title="提示">
      <div class="ivumodal-cont">
        请选择套餐
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="ok(2)">取消</Button>
        <Button class="btn sure" type="success" ghost @click="ok(2)">确定</Button>
      </div>
    </Modal>
    <!-- 同步套餐提示弹框 -->
    <Modal footer-hide class="ivumodal" width="500" v-model="tongerrors" title="提示">
      <div class="ivumodal-cont" style="line-height:40px;font-size:16px;">
        请再次确认同步套餐的价格是否有更新，如有更新，请先停用套餐并联系平台更新套餐售价。再确定具体启用时间。
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="tongerrors = false">取消</Button>
        <Button class="btn sure" type="success" ghost @click="postsynBasExamSuite">确定</Button>
      </div>
    </Modal>
    <Modal footer-hide class="ivumodal" width="500" v-model="specialVerify" title="设置特殊套餐确认">
      <div class="ivumodal-cont" style="line-height:40px;font-size:16px;">
        是否要将这{{selectNum}}个套餐设置为特殊套餐。
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="specialVerify = false">取消</Button>
        <Button class="btn sure" type="success" ghost @click="setSuccess">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Add from "../tan/add";
import {
  formatMoney,
  selectNewBasExamSuiteList,
  selectUploadedBasExamSuiteList,
  updateBasExamSuiteUseState,
  addBasExamSuite,
  synBasExamSuite,
  getSuiteSort,
  deleteSuiteSort,
  addSuiteSort,
  updateSuiteSort,
  savePackageSpecialPackage,
} from "../servers/api";
export default {
  name: "keyong",
  data() {
    return {
      model1: -1,
      ishow: false,
      areaText: "",
      Title: "",
      TitleClassify: "",
      ishowClassify: false,
      typeList: [],
      formValidate: {},
      ruleValidate: {
        classifyName: [
          {
            required: true,
            message: "请输入套餐分类",
            trigger: "blur",
          },
        ],
        classifyNote: [
          {
            required: true,
            message: "请输入套餐分类说明",
            trigger: "blur",
          },
        ],
        currentType: [
          {
            required: true,
            message: "请选择停用或启用",
            trigger: "change",
          },
        ],
      },
      isShuoming: false,
      isiconfontshow: false,
      alertTitleIshow: false,
      alertTitleIshow2: false,
      alertTitle: "",
      tongerrors: false,
      current: 1,
      selectedNum: 1,
      pageSize: 20,
      data: [],
      dataClassify: [],
      columnsClassify: [
        {
          title: "套餐分类ID",
          align: "center",
          width: 90,
          ellipsis: true,
          sortable: true,
          key: "id",
        },
        {
          title: "套餐分类名称",
          width: 150,
          align: "center",
          key: "classifyName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "套餐说明",
          align: "center",
          width: 200,
          ellipsis: true,
          sortable: true,
          key: "classifyNote",
        },
        {
          title: "可用状态",
          width: 80,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "currentType",
          render: (h, params) => {
            let name = "";
            if (params.row.currentType == "0") {
              name = "停用";
            } else if (params.row.currentType == "1") {
              name = "启用";
            }
            return h(
              "div",
              {
                style: {
                  "font-size": "13px",
                },
              },
              name
            );
          },
        },
        {
          title: "操作",
          key: "awssd",
          align: "center",
          width: 220,
          render: (h, params) => {
            let back = "#fff";
            let color = "#7F7F7F";
            back = "#53CAC3";
            color = "#fff";
            return h("span", [
              h(
                "div",
                {
                  style: {
                    marginRight: "7px",
                    marginBottom: "5px",
                    display: "inline-block",
                    "text-align": "center",
                    background: back,
                    border: "1px solid #53CAC3",
                    "border-radius": "5px",
                    width: "65px",
                    height: "28px",
                    cursor: "pointer",
                    "line-height": "28px",
                  },
                  on: {
                    click: () => {
                      //触发事件是on-change,用双引号括起来，
                      //参数value是回调值，并没有使用到
                      this.tonewUpdateClassify(params.row); //params.index是拿到table的行序列，可以取到对应的表格值
                    },
                  },
                },
                "修改"
              ),
              h(
                "div",
                {
                  style: {
                    // width:'50px',

                    "line-height": "28px",
                    "text-align": "center",
                    /* background: back, */
                    background: "#ed4014",
                    border: "1px solid #ed4014",
                    "border-radius": "5px",
                    width: "65px",
                    height: "28px",
                    "margin-left": "12px",
                    cursor: "pointer",
                    display: "inline-block",
                    color: color,
                  },
                  on: {
                    click: () => {
                      this.deleteClassify(params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: "套餐名称",
          width: 250,
          align: "center",
          key: "examSuiteName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "套餐金额",
          align: "center",
          width: 200,
          ellipsis: true,
          sortable: true,
          key: "price",
          render: (h, params) => {
            let a = "￥" + formatMoney(params.row.price);
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    height: "30px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    "line-height": "37px",
                    color: "#7F7F7F",
                  },
                },
                a
              ),
            ]);
          },
        },
        {
          title: "性别",
          align: "center",
          width: 200,
          ellipsis: true,
          sortable: true,
          key: "useSex",
        },
        {
          title: "婚姻状态",
          align: "center",
          width: 200,
          ellipsis: true,
          sortable: true,
          key: "marry",
        },
        {
          title: "套餐说明",
          align: "center",
          width: 300,
          ellipsis: true,
          sortable: true,
          key: "instructions",
        },
        {
          title: "批准可用日期",
          width: 230,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "availableDate",
          // render: (h, params) => {
          //   let a = params.row.availableDate;
          //   let num = ''
          //   if (a) {
          //     num = a.slice(0, 10);
          //   }

          //   return h('div', {
          //     style: {
          //       height: '30px',
          //       'line-height': '30px',
          //       'text-align': 'center',
          //       'font-size': '13px',
          //       color: '#7F7F7F',
          //     }
          //   }, num)
          // }
        },
        {
          title: "停用日期",
          align: "center",
          width: 230,
          ellipsis: true,
          sortable: true,
          key: "stopUseDate",
          // render: (h, params) => {
          //   let a = params.row.stopUseDate;
          //   let num = ''
          //   if (a) {
          //     num = a.slice(0, 10);
          //   }

          //   return h('div', {
          //     style: {
          //       height: '30px',
          //       'line-height': '30px',
          //       'text-align': 'center',
          //       'font-size': '13px',
          //       color: '#7F7F7F',
          //     }
          //   }, num)
          // }
        },
        // {
        //     title: '已购未检',
        //     width: 160,
        //     align: 'center',
        //     ellipsis:true,
        //     sortable: true,
        //     key: 'ss'
        // },
        {
          title: "可用状态",
          width: 200,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "availableState",
          render: (h, params) => {
            let name = "";
            if (params.row.availableState == "0") {
              name = "停用";
            } else if (params.row.availableState == "1") {
              name = "启用";
            }
            return h(
              "div",
              {
                style: {
                  "font-size": "13px",
                },
              },
              name
            );
          },
        },
        // {
        //     title: '同步状态',
        //     align: 'center',
        //     width: 160,
        //     ellipsis:true,
        //     sortable: true,
        //     key: 'ss'
        // },
        {
          title: "操作",
          key: "awssd",
          align: "center",
          width: 110,
          fixed: "right",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  // width:'50px',
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  background: "#fff",
                  border: "1px solid #53CAC3",
                  "border-radius": "5px",
                  width: "50px",
                  "margin-left": "15px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.chengeTable(params.row);
                  },
                },
              },
              "修改"
            );
          },
        },
      ],
      selectNum: 0, //已选数量
      selectList: [],
      addShow: false,
      modify: false,
      xiugai: {
        num: "",
        select: "1",
        marry: "",
      },
      xiugaidata: {
        select: [
          {
            required: true,
            message: "请选择可用状态",
            trigger: "change",
          },
        ],
        marry: [
          {
            required: true,
            message: "请选择婚姻状态",
            trigger: "change",
          },
        ],
      },
      orderField: "",
      name: "",
      isAsc: "",
      obj: {},
      list: [],
      addSelectd: [],
      errors: false,
      specialVerify: false,
    };
  },
  methods: {
    formValidateReset(name) {
      //弹窗 取消
      this.$refs[name].resetFields();
      this.ishow = false;
    },
    formValidateSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.TitleClassify === "新增套餐分类") {
            let params = {
              classifyName: this.formValidate.classifyName,
              classifyNote: this.formValidate.classifyNote,
              currentType: this.formValidate.currentType,
            };
            addSuiteSort(params).then((res) => {
              if (res.data.code == 1) {
                this.ishow = false;
                this.getSuiteSort();
              }
            });
          } else {
            let params = {
              classifyName: this.formValidate.classifyName,
              classifyNote: this.formValidate.classifyNote,
              currentType: this.formValidate.currentType,
              id: this.formValidate.id,
            };
            updateSuiteSort(params).then((res) => {
              if (res.data.code == 1) {
                this.ishow = false;
                this.getSuiteSort();
              }
            });
          }
        }
      });
      //弹窗 确定
    },
    tonewClassifyManage() {
      this.ishowClassify = true;
    },
    deleteClassify(row) {
      deleteSuiteSort({ id: row.id }).then((res) => {
        if (res.data.code == 1) {
          this.getSuiteSort();
        }
      });
    },
    getSelect(name) {
      //     console.log(name,'this.model1')
      this.selectUploadedBasExamSuiteList();
    },
    tonewUpdateClassify(item) {
      //修改
      item.showOrder = item.showOrder + "";
      this.TitleClassify = "修改套餐分类";
      let obj = JSON.parse(JSON.stringify(item));
      this.formValidate = obj;
      this.formValidate.currentType = obj.currentType.toString();
      /* this.formValidate.classifyName = item.classifyName
              this.formValidate.classifyNote = item.classifyNote
              this.formValidate.currentType = item.currentType.toString()
              this.formValidate.id = item.id */
      this.ishow = true;
    },
    tonewAddClassify() {
      this.ishow = true;
      this.TitleClassify = "新增套餐分类";
      this.formValidate = {};
      this.$refs["formValidate"].resetFields();
    },
    ok() {
      this.errors = false;
    },
    postsynBasExamSuite() {
      //同步接口
      this.isiconfontshow = true;
      let list = [];
      for (let i = 0; i < this.selectList.length; i++) {
        list.push(this.selectList[i].id);
      }
      let params = {
        idList: list.join(","),
      };
      synBasExamSuite(params).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
          this.selectChange([]);
          this.selectUploadedBasExamSuiteList(1);
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
        this.tongerrors = false;
      });
    },
    tongbu() {
      //同步
      if (this.selectNum > 0) {
        this.tongerrors = true;
        return;
      } else {
        this.errors = true;
      }
    },
    getSelectd(list) {
      //子组件接受选中套餐
      if (list.length === 0) {
        // 点击的取消
        this.addShow = false;
      } else {
        // 点击的确定
        this.addSelectd = list;
        this.addShow = false;
        this.addBasExamSuite();
      }
    },
    getSuiteSort() {
      getSuiteSort().then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          this.typeList = res.data.data;
          this.dataClassify = res.data.data;
        }
      });
    },
    selectUploadedBasExamSuiteList(index) {
      //列表
      this.isiconfontshow = true;
      if (index) {
        this.current = 1;
      }
      let params = {
        name: this.name,
        orderField: this.orderField,
        isAsc: this.isAsc,
        pageNum: this.current,
        pageSize: this.pageSize,
        sortId: this.model1,
      };
      selectUploadedBasExamSuiteList(params).then((res) => {
        if (res.data.code == 1) {
          this.selectChange([]);
          this.isiconfontshow = false;
          this.obj = res.data.data;
          this.data = res.data.data.list;
        }
      });
    },
    tonewAdd() {
      //点击新增
      this.Title = "新增套餐";
      this.$refs.Add.selectNewBasExamSuiteList();
      this.addShow = true;
    },
    changePeoplecurrent(num) {
      //换页
      this.current = num;
      this.selectList = [];
      this.selectNum = this.selectList.length;
      this.selectUploadedBasExamSuiteList();
    },
    changepeoplepage(num) {
      //换每页请求多少条
      this.selectList = [];
      this.selectNum = this.selectList.length;
      this.pageSize = num;
      this.selectUploadedBasExamSuiteList();
    },
    changesort(item) {
      //排序
      this.orderField = item.key;
      this.isAsc = item.order;
      this.current = 1;
      if (item.order == "normal") {
        this.isAsc = "";
        this.orderField = "";
      }
      this.selectUploadedBasExamSuiteList();
    },
    piliang() {
      //批量修改
      if (this.selectNum > 0) {
        this.isShuoming = true;
        this.xiugai.instructions = "";
        this.xiugai.precautions = "";
        this.modify = true;
        this.selectedNum = this.selectNum;
        this.list = this.selectList;
      } else {
        this.errors = true;
      }
    },
    selectChange(item) {
      //表格select选中
      this.selectList = item;
      this.selectNum = this.selectList.length;
    },
    clear(index, name) {
      //取消 确定
      if (index == 1) {
        if (this.$refs["xiugai"].resetFields()) {
          this.$refs["xiugai"].resetFields();
        }
        this.modify = false;
        return;
      } else {
        // 修改确定
        if (this.isShuoming) {
          this.updateBasExamSuiteUseState();
        } else {
          this.$refs[name].validate((valid) => {
            if (valid) {
              this.updateBasExamSuiteUseState();
            }
          });
        }
      }
    },
    addBasExamSuite() {
      //新增套餐
      this.isiconfontshow = true;
      let list = [];
      let str = "";
      console.log(this.addSelectd, "this.this.addSelectd");
      for (let i = 0; i < this.addSelectd.length; i++) {
        str =
          this.addSelectd[i].idExamSuite + "-" + this.addSelectd[i].classifyId;
        // list.push(this.addSelectd[i].idExamSuite);
        list.push(str);
      }
      let params = {
        idList: list.join(","),
      };
      addBasExamSuite(params).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
          this.selectChange([]);
          this.selectUploadedBasExamSuiteList();
          this.addShow = false;
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    updateBasExamSuiteUseState() {
      //修改还状态
      this.isiconfontshow = true;
      let joinList = [];
      for (let i = 0; i < this.list.length; i++) {
        joinList.push(this.list[i].id);
      }
      let params = {
        idList: joinList.join(","),
        useState: this.xiugai.select,
        instructions: this.xiugai.instructions,
        precautions: this.xiugai.precautions,
        marriage: this.xiugai.marry,
      };
      updateBasExamSuiteUseState(params).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
          let idListArr = params.idList.split(",");
          if (idListArr.length == 1) {
            this.data.find((item) => item.id == params.idList).instructions =
              params.instructions;
            this.data.find((item) => item.id == params.idList).marry =
              params.marriage;
            this.data.find((item) => item.id == params.idList).availableState =
              params.useState;
          } else {
            for (var i in idListArr) {
              this.data.find((item) => item.id == idListArr[i]).availableState =
                params.useState;
            }
          }

          this.modify = false;
          this.selectChange([]);
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    chengeTable(item) {
      //点击修改
      if (this.$refs["xiugai"].resetFields()) {
        this.$refs["xiugai"].resetFields();
      }
      this.list = [];
      this.isShuoming = false;
      this.selectedNum = 1;
      this.list.push(item);
      this.modify = true;
      this.xiugai.select = JSON.parse(JSON.stringify(item)).availableState + "";
      this.xiugai.instructions = JSON.parse(JSON.stringify(item)).instructions;
      this.xiugai.precautions = JSON.parse(JSON.stringify(item)).precautions;
      if (item.marry) {
        this.xiugai.marry = JSON.parse(JSON.stringify(item)).marry;
      } else {
        this.xiugai.marry = "";
      }
    },
    setSpecialSuit() {
      this.specialVerify = true;
    },
    setSuccess() {
      let idArr = [];
      this.selectList.forEach((element) => {
        idArr.push(element.idExamSuite);
      });
      savePackageSpecialPackage({
        ids: idArr.toString(),
      }).then((res) => {
        if (res.data.code === 1) {
          this.specialVerify = false;
          this.$Message.success("设置成功");
          this.selectUploadedBasExamSuiteList();
        }
      });
    },
  },
  created() {
    this.selectUploadedBasExamSuiteList();
    this.getSuiteSort();
  },
  components: {
    Add,
  },
};
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.keyong {
  padding: 15px;
  font-size: 13px;
  height: 100%;
  width: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  .top {
    width: calc(100% - 250px);
    height: 60px;
    line-height: 35px;
    position: fixed;
    top: 111px;
    z-index: 99;
    background: #fff;
    padding-top: 17px;
    left: 220px;
    padding-left: 15px;
    padding-bottom: 15px;
  }
  .select {
    width: 130px;
    margin-right: 10px;
  }
  .journal-input {
    width: 250px;
    vertical-align: top;
  }
  .title-btn {
    float: right;
    margin-left: 10px;
  }
  .title-btn2 {
    width: 110px;
    float: right;
    margin-left: 10px;
    line-height: 18px;
  }
  .table-cont {
    padding-top: 15px;
    margin: 40px 0 50px;
  }
  .page-div {
    width: 100%;
    margin-top: 15px;
    position: fixed;
    background: #fff;
    width: calc(100% - 270px);
    height: 60px;
    z-index: 99;
    bottom: 0;
    padding-top: 15px;
    .page-div-left {
      float: left;
      line-height: 30px;
    }
    .page-div-page {
      float: right;
      margin-right: 15px;
    }
    .title-btn {
      margin-left: 15px;
    }
  }
  .left {
    float: left;
    padding-right: 15px;
    border-right: 1px solid #d7d7d7;
  }
}

.bumenModal-item {
  margin-bottom: 10px;
}
.bumenModal-item {
  margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/yuyue/keyong.vue